import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddLocationState, addLocationFeatureKey } from './add-location.reducer';

const getAddLocationFeature = createFeatureSelector<AddLocationState>(addLocationFeatureKey);

export const getAddLocationCallState = createSelector(getAddLocationFeature, (state) => {
   return state.callState;
});
